import React from 'react';
import { View, Text, Button, StyleSheet } from 'react-native';
import connection_change from "@/Assets/Images/Svgs/connection_change.svg"
import CCButton from '@/Atoms/CCButton';
import CCColors from '@/Utils/CCColors';
import CCText from '@/Atoms/CCText';

const ConnectionModal = ({ visible, onContinue, onClose, authFail = false, onboarding_completed = true, }) => {
  if (!visible) return null; // Render nothing if not visible

  // const heading = authFail
  //   ? 'Auth Failed'
  //   : 'Circlechess was opened in another tab.';

  // const body = authFail
  //   ? 'We couldn’t authenticate your session. Please reconnect to continue using CircleChess.'
  //   : 'We only support gameplay mode in a single tab. However you can continue using other features of CircleChess.';

  // const disclaimer = authFail
  //   ? ''
  //   : 'This will lock gameplay mode in other tab if open';

  // helper to select heading, body, and button text
  function getCopy({ authFail, onboardingCompleted }) {
    if (authFail) {
      return {
        heading: 'Auth Failed',
        body:
          'We couldn’t authenticate your session. Please reconnect to continue using CircleChess.',
        disclaimer: '',
        buttonLabel: 'Reconnect',
      };
    }

    if (!onboardingCompleted) {
      return {
        heading: 'Complete Your Onboarding',
        body:
          'Please finish onboarding to access this feature and the full CircleChess experience.',
        disclaimer: '',
        buttonLabel: 'Continue Onboarding',
      };
    }

    return {
      heading: 'CircleChess was opened in another tab.',
      body:
        'We only support gameplay mode in a single tab. However you can continue using other features of CircleChess.',
      disclaimer: 'This will lock gameplay mode in other tab if open',
      buttonLabel: 'Activate Gameplay Here',
    };
  }

  const { heading, body, disclaimer, buttonLabel } = getCopy({
    authFail,
    onboardingCompleted: onboarding_completed,
  });

  return (
    <View style={styles.overlayContainer}>
      <View style={styles.modalView}>
        <img src={connection_change} style= {{marginTop:'5%', marginBottom: '3%'}}></img>
        <CCText style={styles.modalHeadingText}>
          {heading}
        </CCText>
        <CCText style={styles.modalText}>
        {body}
        </CCText>
        <View style={styles.buttonContainer}>
          <CCButton onPress={onContinue} style={{alignSelf: 'center', width: '60%', backgroundColor: CCColors.Primary.Light, height: '100%',padding: '0%'}} >
            <CCText style={{ color: 'black', alignContent: 'center' }} fontSize={14}>{buttonLabel}</CCText>
          </CCButton>
          {/* <Button title="Navigate to Dashboard" onPress={onClose} color="red" /> */}
        </View>
        <CCText style={styles.disclaimerText}>
        {disclaimer}
        </CCText>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  overlayContainer: {
    position: 'absolute',
    top: '0%', // Adjust this value to control where the overlay appears
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalView: {
    width: 450,
    height: 360,
    padding: 20,
    backgroundColor: 'white',
    borderRadius: 10,
    alignItems: 'center',
  },
  modalHeadingText: {
    fontSize: 20,
    marginBottom: 20,
    textAlign: 'center',
    fontWeight: 180,
  },
  modalText: {
    fontSize: 16,
    marginBottom: 20,
    marginLeft: '10%',
    marginRight: '10%',
    textAlign: 'center',
    fontWeight: 20,
  },
  disclaimerText: {
    fontSize: 12,
    marginTop: 20,
    marginLeft: '5%',
    marginRight: '5%',
    textAlign: 'center',
    fontWeight: 20,
  },
  buttonContainer: {
    width: '100%',
    height: '10%'
  },
});

export default ConnectionModal;

